import { render, staticRenderFns } from "./ReferenciaPersonalDialogComponent.vue?vue&type=template&id=641c3792"
import script from "./ReferenciaPersonalDialogComponent.vue?vue&type=script&lang=js"
export * from "./ReferenciaPersonalDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports